// extracted by mini-css-extract-plugin
module.exports = {"TheComp":"DeviceSwiper_TheComp__lbqOr"};